<!--
 * @Descripttion: 收藏页面日历组件
 * @Author: Niu Chenxin
 * @Date: 2021-01-14 11:15:25
 * @LastEditors: Niu Chenxin
 * @LastEditTime: 2021-02-18 10:41:08
-->
<template>
  <div class="list_item_calendar">
    <van-list class="list_wrap" v-model="calendarParams.Loading" :finished="calendarParams.Finished" :finished-text="calendarParams.finishText" :error.sync="calendarParams.Error" error-text="请求失败，点击重新加载" @load="getCalendar">
      <div class="flowCalen">
        <div v-for="items in calendarList" :key="items.id" @click="enlargeImgOpen(true,items)">
          <img :src="items.imgUrl" v-lazy='items.imgUrl' alt="">
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import API from '@/utils/axiosApi/calendarApi'
export default {
  props: {
    fomatterNum: {
      type: Function
    },
    getCookie: {
      type: Function
    },
    cancelItem: {
      type: Object
    }
  },
  data () {
    return {
      calendarParams: {
        page: 1,
        size: 24,
        Loading: false, // 是否加载状态
        Finished: false, // 是否加载完成
        Error: false, // 是否加载失败
        finishText: '', // 加载完成文本
      },
      calendarList: []
    }
  },
  watch: {
    cancelItem: {
      handler () {
        if (this.cancelItem.orFavorites) {
          this.calendarList.push(this.cancelItem);
        } else {
          this.calendarList.splice(this.calendarList.findIndex(item => this.cancelItem.id === this.cancelItem.id), 1)
        }
      }
    }
  },
  mounted () { },
  methods: {
    getCalendar () {
      const _this = this;
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      API.getCollectByCalendar({}, { crmId: userInfo.crm_id, page: _this.calendarParams.page, size: _this.calendarParams.size }, res => {
        this.calendarParams.Loading = false;
        if (res.code == "200") {
          _this.calendarList = _this.calendarList.concat(res.data.content)
          if (_this.calendarParams.page >= Math.ceil(res.data.totalElements / _this.calendarParams.size)) {
            this.calendarParams.Finished = true;
            this.calendarParams.finishText = "——已经到底了哦——";
          } else {
            this.calendarParams.page += 1;
          }
          if (this.calendarParams.page == 1 && res.data.content.length == 0) {
            this.calendarParams.finishText = "";
            this.$emit('isEmpty', true)
            $(".van-tabs__content").css("background", "#fff");
          }
        } else {
          this.calendarParams.Loading = false;
          this.calendarParams.Error = true
        }
      }, res => {
        this.calendarParams.Loading = false;
        this.calendarParams.Error = true;
      })
    },
    initFn () {
      this.calendarParams.Finished = false;
      this.calendarParams.Error = false;
      this.calendarParams.Loading = false;
      this.calendarList = [];
      this.calendarParams.page = 1;
    },
    collectChange (flag, obj) {
      if (flag) {
        this.calendarList.push(obj);
        this.calendarParams.finishText = "——已经到底了哦——";
        this.$emit('isEmpty', false)
        $(".van-tabs__content").css("background", "#fff");
      } else {
        const start = this.calendarList.findIndex(item => item.id == obj.id)
        this.calendarList = this.calendarList.slice(0, start).concat(this.calendarList.slice(start + 1, this.calendarList.length))
        if (this.calendarList.length == 0) {
          this.calendarParams.finishText = "";
          this.$emit('isEmpty', true)
          $(".van-tabs__content").css("background", "#fff");
        }
      }
    },
    // 育儿日历放大弹窗
    enlargeImgOpen (flag, data) {
      this.$emit('enlargeImgOpen', flag, data)
    }
  }
}
</script>

<style lang="less" scoped>
.list_item_calendar {
  // 瀑布流形式
  .flowCalen {
    padding: 12px 2px 0 12px;
    background: #fff;
    overflow: hidden;

    div {
      width: 112px;
      height: 181px;
      line-height: 181px;
      margin-right: 8px;
      margin-bottom: 8px;
      float: left;
      background: #f2f2f2;

      img {
        width: 112px;
        vertical-align: middle;
      }
    }

    .finished-text {
      width: 100%;
      color: #999;
      font-size: 14px;
      padding: 40px 0;
      text-align: center;
      float: left;
    }
  }
}
</style>